import React, { useEffect, useMemo, useState, useRef } from 'react';
import { filterItems } from '../../../utils/submissions';
import FilterItem from './FilterItem';

const FilterItems = ({ openDropdown, fieldClickHandler, closeFilterDropdown }) => {
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const inputRef = useRef(null);

  useEffect(() => {
    if (openDropdown) {
      document.addEventListener('keydown', handleKeyDown);
      inputRef.current?.focus();
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    const length = filterItems.length;
    if (!length) return;

    switch (event.key) {
      case 'Escape':
        closeFilterDropdown?.();
        break;
      case 'Enter':
        if (highlightedIndex >= 0) {
          fieldClickHandler(filterItems[highlightedIndex]);
        }
        break;
      case 'ArrowDown':
        event.preventDefault();
        setHighlightedIndex((prev) => (prev + 1) % length);
        break;
      case 'ArrowUp':
        event.preventDefault();
        setHighlightedIndex((prev) => (prev - 1 + length) % length);
        break;
      default:
        break;
    }
  };

  return (
    <div className="bg-[#2c2d33] border border-[#85869833] rounded-md shadow">
      <ul className="flex flex-col m-1 overflow-y-auto">
        {filterItems.map((field, index) => (
          <FilterItem
            key={index}
            field={field}
            isHighlighted={highlightedIndex === index}
            onClick={() => fieldClickHandler(field)}
            onMouseEnter={() => setHighlightedIndex(index)}
          />
        ))}
      </ul>
    </div>
  );
};

export default FilterItems;
